import {
  GET_INSTITUTIONS_REQUEST,
  GET_INSTITUTIONS_SUCCESS,
  GET_INSTITUTIONS_FAILURE,

  CREATE_CONSENT_REQUEST,
  CREATE_CONSENT_SUCCESS,
  CREATE_CONSENT_FAILURE,
} from "store/actions/application-actions";

const initialState = {
  institutions: [],
  loading: false,
  error: null,
  consentRedirectUrl: null,

};

export default function applicationReducer(state = initialState, action) {
  switch (action.type) {
    case GET_INSTITUTIONS_REQUEST:
      return { ...state, loading: true, error: null };

    case GET_INSTITUTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        institutions: action.payload?.data || action.payload,
      };

    case GET_INSTITUTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error:
          action.payload?.message ||
          action.payload?.error ||
          'Erro ao carregar instituições.',
      };

    case CREATE_CONSENT_REQUEST:
      return { ...state, loading: true, error: null };

    case CREATE_CONSENT_SUCCESS:
      return {
        ...state,
        loading: false,
        consentRedirectUrl: action.payload?.consentRedirectUrl || null,
      };

    case CREATE_CONSENT_FAILURE:
      return {
        ...state,
        loading: false,
        error:
          action.payload?.message ||
          action.payload?.error ||
          'Erro ao criar consentimento.',
      };

    default:
      return state;
  }
}
